define(['lodash'], function(_) {

    function Error(template, value, data) {
       this.message = template + ': ' + value + '\n' + JSON.stringify(data);
       this.name = "Url Template Error";
    }

    var inline_re = /{(\w+)}/g,
        params =    {
            '?': /{\?([\w\,]+)}/,
            '&': /{&([\w\,]+)}/
        };

    function urltemplate(template, data) {
        data = data || {};
        var url = template.replace(inline_re, function(match, captured) {
            if (captured in data) {
                return data[captured];
            }
            throw new Error(template, captured, data);
        });
        _.forEach(params, function(pattern, prefix) {
            url = url.replace(pattern, function(match, captured) {
                var params = _.map(_.pick(data, captured.split(',')), function(value, key) {
                    return key + '=' + value;
                }).join('&');
                return params ? prefix + params : '';
            });
        });
        return url;
    }
    urltemplate.Error = Error;
    urltemplate.vars = function vars(template) {
        var result = {required: [], optional: []};
        var match;
        while (true) {
            match = inline_re.exec(template);
            if (match === null) { break; }
            result.required.push(match[1]);
        }
        _.forEach(params, function(pattern) {
            match = pattern.exec(template);
            if (match !== null) {
                result.optional = result.optional.concat(match[1].split(','));
            }
        });
        return result;
    };
    return urltemplate;
});



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/urltemplate.js
 **/